import { render, staticRenderFns } from "./shipperForm.vue?vue&type=template&id=f95183ae&scoped=true"
import script from "./shipperForm.vue?vue&type=script&lang=js"
export * from "./shipperForm.vue?vue&type=script&lang=js"
import style0 from "./shipperForm.vue?vue&type=style&index=0&id=f95183ae&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95183ae",
  null
  
)

export default component.exports